<div class="upload-modal-container">
	<div class="upload-section">
		<p-fileUpload
			#fileUpload
			name="document"
			[customUpload]="true"
			(onSelect)="onFileSelect($event)"
			(onRemove)="onRemoveFile()"
			[multiple]="false"
			[showUploadButton]="false"
			[showCancelButton]="false"
			accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
			[maxFileSize]="10000000"
			[disabled]="isUploading"
			chooseLabel="Select File"
		>
			<ng-template pTemplate="content" let-files>
				<div class="upload-content" *ngIf="files.length === 0" (click)="fileUpload.choose()">
					<div class="upload-placeholder">
						<i class="pi pi-cloud-upload" style="font-size: 3rem; color: var(--primary-color)"></i>
						<p class="mt-3 mb-2 text-lg">Drag and drop file here</p>
						<p class="text-color-secondary text-sm">or click to browse</p>
						<p class="text-color-secondary text-xs mt-2">Supported: PDF, JPG, PNG, DOC, DOCX (Max 10MB)</p>
					</div>
				</div>
			</ng-template>

			<ng-template pTemplate="file" let-file let-i="index">
				<div class="file-selected-info">
					<div class="flex align-items-center gap-3 p-3">
						<i class="pi pi-file-pdf text-5xl text-primary" *ngIf="file.type === 'application/pdf'"></i>
						<i class="pi pi-image text-5xl text-primary" *ngIf="file.type.startsWith('image/')"></i>
						<i
							class="pi pi-file-word text-5xl text-primary"
							*ngIf="
								file.type ===
									'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
								file.type === 'application/msword'
							"
						></i>
						<i
							class="pi pi-file text-5xl text-primary"
							*ngIf="
								!file.type.startsWith('image/') &&
								file.type !== 'application/pdf' &&
								file.type !==
									'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
								file.type !== 'application/msword'
							"
						></i>
						<div class="flex-1">
							<div class="font-semibold text-lg">{{ file.name }}</div>
							<div class="text-sm text-color-secondary mt-1">{{ formatFileSize(file.size) }}</div>
						</div>
						<p-button
							icon="pi pi-times"
							[text]="true"
							[rounded]="true"
							severity="secondary"
							(onClick)="fileUpload.remove($event, i)"
							pTooltip="Remove file"
							tooltipPosition="top"
						/>
					</div>
				</div>
			</ng-template>
		</p-fileUpload>
	</div>

	<div class="flex gap-2 justify-content-end mt-4">
		<p-button label="Cancel" [outlined]="true" (onClick)="onCancel()" [disabled]="isUploading" />
		<p-button
			label="Upload"
			icon="pi pi-upload"
			(onClick)="onUpload()"
			[disabled]="!canUpload()"
			[loading]="isUploading"
		/>
	</div>
</div>
